<div class="p-grid">
  <div class="p-col-10 m-auto pt-5 p-d-flex p-jc-between">
    <div class="p-grid">
      <p-card class="p-xl-6 p-lg-12 p-md-12 p-sm-12" header="{{'USUARIO.INDIVIDUALES.TITULO' | translate}}">
        <div class="p-grid p-justify-even p-align-end">
          <i class="dum-fa fas fa-wheelchair fa-3x"></i>
          <i class="dum-fa fas fa-charging-station fa-3x"></i>
          <i class="dum-fa fas fa-truck fa-3x"></i>
          <p class="nmt">
            {{'USUARIO.INDIVIDUALES.TEXTO1' | translate}}
          </p>
          <p class="nmt">
            {{'USUARIO.INDIVIDUALES.TEXTO2' | translate}}
          </p>
          <p class="nmt">
            {{'USUARIO.INDIVIDUALES.TEXTO3' | translate}}
          </p>
        </div>
      </p-card>
      <p-card class="p-xl-6 p-lg-12 p-md-12 p-sm-12" header="{{'USUARIO.EMPRESAS.TITULO' | translate}}">
        <div class="p-grid p-justify-even p-align-end">
          <i class="dum-fa fas fa-car-side fa-2x cont"></i>
          <i class="dum-fa fas fa-building fa-3x cont"></i>
          <i class="dum-fa fas fa-truck fa-2x cont"></i>
          <i class="dum-fa fas fa-industry fa-3x p-ml-2 cont"></i>
          <i class="dum-fa fas fa-warehouse fa-3x p-ml-2 cont"></i>
          <p class="nmt">
            {{'USUARIO.EMPRESAS.TEXTO1' | translate}}
          </p>
          <p class="nmt">
            {{'USUARIO.EMPRESAS.TEXTO2' | translate}}
          </p>
          <p class="nmt">
            {{'USUARIO.EMPRESAS.TEXTO3' | translate}}
          </p>
        </div>
      </p-card>
    </div>
  </div>
</div>